const initialState = { PatientFileInfo: {}, TeamArr: [], reviewArr: [], blogArr: [], clinicInfo: [], eventArr: [], careersArr: [], onlineConsultation: [],reviewHome: [],galleryArr:[] };


const rootReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'PATIENT_FILE_INFO':
      return { ...state, PatientFileInfo: action.payload };
    case 'TEAM_DATA':
      return { ...state, TeamArr: action.payload };
    case 'REVIEW_DATA':
      return { ...state, reviewArr: action.payload };
    case 'REVIEW_HOME':
      return { ...state, reviewHome: action.payload };
    case 'BLOGS_DATA':
      return { ...state, blogArr: action.payload };
    case 'CLINIC_INFO':
      return { ...state, clinicInfo: action.payload };
    case 'EVENT_DATA':
      return { ...state, eventArr: action.payload };
    case 'CAREERS_DATA':
      return { ...state, careersArr: action.payload };
    case 'CONSULTATION_INFO':
      return { ...state, onlineConsultation: action.payload };
      //GALLERY_DATA
      case 'GALLERY_DATA':
        return { ...state, galleryArr: action.payload };
    default:
      return state
  }
}
export default rootReducer;
